import React, { useState } from "react";
import InputWithoutTitle from "../../../components/InputWithoutTitle";
import Dropdown from "../../../components/Dropdown";
import Pagination from "../../../components/Pagination";
import ButtonSelectedItems from "../../../components/ButtonSelectedItems";
import CheckItem from "../../../components/CheckItem";
import AddReasonDialog from "./AddReasonDialog";
import AttendanceTable from "./AttendanceTable";
export default function AttendancePage() {
  const [isShow, setIsShow] = useState(false);

  return (
    <div className="pt2">
      <div className="grid70-30">
        <InputWithoutTitle />
        <Dropdown
          items={["1/2564", "2/2564", "1/2563", "2/2563"]}
          itemCallback={(item) => {
            console.log(item);
          }}
          hasFilter={true}
        />
      </div>
      <div className="box-on-top-attendance-page">
        <div className="box-dash-attendance-page">
          <div className="row-jcsb">
            <p className="txt-main-content4">Hight-Temp-Number</p>
            <p className="txt-main-content4">135 คน</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Most Temp</p>
            <p className="txt-main-content4">39.5</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Env Temp</p>
            <p className="txt-main-content4">36.8</p>
          </div>
        </div>
        <div className="box-dash-attendance-page">
          <div className="row-jcsb">
            <p className="txt-main-content4">Hight-Temp-Number</p>
            <p className="txt-main-content4">135 คน</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Most Temp</p>
            <p className="txt-main-content4">39.5</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Env Temp</p>
            <p className="txt-main-content4">36.8</p>
          </div>
        </div>
        <div className="box-dash-temperature-page">
          <div className="row-jcsb">
            <p className="txt-main-content4">Hight-Temp-Number</p>
            <p className="txt-main-content4">135 คน</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Most Temp</p>
            <p className="txt-main-content4">39.5</p>
          </div>
          <div className="row-jcsb">
            <p className="txt-main-content4">Env Temp</p>
            <p className="txt-main-content4">36.8</p>
          </div>
        </div>
      </div>
      <AttendanceTable />
      <div className="row-jcfe-my2">
        <Pagination />
      </div>
      <ButtonSelectedItems
        addClick={() => {
          // resetQuery();
          setIsShow(true);
        }}
        addTitle={"Add Reason"}
      />
      <AddReasonDialog
        isShow={isShow}
        backgroundClick={() => {
          setIsShow(false);
        }}
        cancelClick={() => {
          setIsShow(false);
        }}
      />
    </div>
  );
}
